/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Activation_Error_ToastInputs */



/**
* | output |
* | --- |
* | "There was an error with activation." |
*
* @param {Login_Offline_Activation_Error_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_activation_error_toast = /** @type {((inputs?: Login_Offline_Activation_Error_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Activation_Error_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une erreur s'est produite lors de l'activation.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bei der Aktivierung ist ein Fehler aufgetreten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Si è verificato un errore durante l'attivazione.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Произошла ошибка при активации.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Hubo un error con la activación.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("激活过程中出现错误。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アクティベーション中にエラーが発生しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सक्रियण में त्रुटि हुई।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ocorreu um erro na ativação.")
	return /** @type {LocalizedString} */ ("There was an error with activation.")
});